import PropTypes from 'prop-types';
export const searchResultsContentPropTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string,
      label: PropTypes.string
    })),
    button: PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string
    })
  }))
};